import React, { useState, useEffect , useRef, memo  } from "react";
import "./ExploreResponseDetails.scss";
import { useSelector, useDispatch } from "react-redux";
import { Collapse, Table, Space, Tooltip, Row, Spin , Modal , Button , Badge } from "antd";
import { LoadingOutlined , DownloadOutlined, ExclamationCircleOutlined, PlusCircleOutlined,MinusCircleOutlined  } from "@ant-design/icons";
import AddToFindingsIcon from "../../assets/icons/add-to-findings-new.svg";
import AddToFindingsDisabledIcon from "../../assets/icons/add-to-findings-disabled.svg";
// import AddAllToReportArrowIcon from "../../assets/icons/addAllCardsArrow.svg";
import AddAllToReportArrowIcon from "../../assets/icons/addAllCardsRightArrow.png";
import AddAllCardsRightArrowDisabled from "../../assets/icons/addAllCardsRightArrowDisabled.png";

import ResponseDetailIcon from "../../assets/icons/respone-details-new.svg";
import UnpinIcon from "../../assets/icons/unpin-icon.svg";
import PinnedIcon from "../../assets/icons/pinned-icon.svg";
import ResponseDetails from "../response-details-drawer/ResponseDetails";
import NeutralIcon from "../../assets/icons/Neutral-icon.svg";
import AgreeIcon from "../../assets/icons/Agree-blue-thumb.svg";
import Disagree from "../../assets/icons/Disagree-orange-thumb.svg";
import FindingReportSettingsModal from "../finding-report-setting-modal/FindingReportSettingsModal";
import {
  getResponsesCategory,
  getQuestionsByCategory,
  setPinUnpinQuestions,
  addMultipleCards,
  checkAsyncStatus,
  downloadOpenTextResponses
} from "../../services/ResponsesAPI";
import {
  setFindingsReportAddSupportingData,
  setHighlightCardData,
  setSupportingData,
  setFilterData,
  setRecordData,
  setUseCaseId,
  setAddAllClicked,
  setNotificationData,
  setExceedingCardsInReport,
  setLoadingDisplayCategoryQuesData,
  setAddMultipleCardsApiRunning,
  setAsyncApiResponse,
  setTabName,
  setMinimizedOpenedReport
} from "../../reducer/PEBCommonSlice";
import { NotificationTypes } from "../../shared/Notification/Notification";
import { saveFindingsReportData } from "../../services/ExperienceBankAPI";
import aesEncryt from "../../shared/AesEncryt/AesEncryt";
import { MAX_ALLOWED_CARDS } from "../../constants/ResponseDetailConstant";
import { InfoCircleOutlined } from '@ant-design/icons';

// const { Panel } = Collapse;

const ExploreResponseDetails = ({screenName}) => {
  const dispatch = useDispatch();
  useEffect(()=>{
    // for showing diff counts for pilot

    if(screenName==="responses"){
      dispatch(setTabName("View Insights"));
    }else{
      dispatch(setTabName(screenName));
    }
    
  },[screenName])
  // YS
  // const MAX_ALLOWED_CARDS = 250;

  const IsReportOpen = useSelector((state) => state.PEBCommon?.findingsReport.isOpen);

  const edit_access_flag = useSelector(
    (state) => state.PEBCommon?.hasAccessToReport
  );
  const deleteCardRefresh = useSelector(
    (state) => state.PEBCommon?.deleteCardRefresh
  );
  const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details
  const userId = userInfo.user_id;
  
  const searchString = useSelector(
    (state) => state.PEBCommon?.searchTextExplore
  );  
  const filterAppliedData = useSelector(
    (state) => state.PEBCommon?.exploreFilterApplyData
  );
  // it is used to update when delete is performed
   const counter = useSelector(
      (state) => state.PEBCommon?.counter
    );
  const loadingDisplayCategoryQuesData  = useSelector(
    (state) => state.PEBCommon?.loadingDisplayCategoryQuesData
  );
  // YS
  // const [totalNumberOfCardsState,setTotalNumberOfCardsState] = useState(0);
 
  const totalNumberOfCards = useSelector(
    (state) => state.PEBCommon?.findingsReport?.supporting_data
  );
  const totalNumberOfCardsRef = useRef(totalNumberOfCards.length);
  const respondentsCount =  useSelector(
    (state) => state.PEBCommon?.respondentsCount
  );
  // const exceedingCardsInReport = useSelector(
  //   (state) => state.PEBCommon?.exceedingCardsInReport
  // );
    useEffect(() => {
      const debounceId = setTimeout(() => {   
        getCategoriesForResponses();        
        onChange([...activeKeys],'',true);
      }, 1000);
  
      // Clear the timeout on unmount or when the searchTerm changes
      return () => clearTimeout(debounceId);
    }, [respondentsCount]);


  useEffect(()=>{
    // console.log("totalNumberOfCards",totalNumberOfCards.length);
    
    // setTotalNumberOfCardsState(totalNumberOfCards.length);
    totalNumberOfCardsRef.current = totalNumberOfCards.length;
  },[totalNumberOfCards])
  // const analysisId = useSelector(
  //   (state) => state.PEBCommon?.findingsReport.analysisId
  // );

  const asyncApiResponse = useSelector(
    (state) => state.PEBCommon?.asyncApiResponse
  );

  useEffect(()=>{
    // console.log("thor asyncApiResponse,totalNumberOfCards",asyncApiResponse,totalNumberOfCards.length);
    
    if(asyncApiResponse){
      dispatch(
        setNotificationData({
          type: NotificationTypes.SUCCESS,
          duration: 10,
          message: (
            <>
              <strong>Process Completed: </strong> 
              {/* <br/> */}
              {`Total Cards Added to Export - ${totalNumberOfCards.length}/${MAX_ALLOWED_CARDS}`}
            </>
          ),
        })
      );
      dispatch(setAsyncApiResponse(false));

    }

  },[asyncApiResponse,totalNumberOfCards])


  const analysisData = useSelector(
    (state) => state.PEBCommon?.findingsReport.analysisData
  );
  const findingsReport= useSelector(
    (state) => state.PEBCommon?.findingsReport
  );
  const filterData = useSelector((state) => state.PEBCommon?.filterData);
  const useCaseData = useSelector((state) => state.PEBCommon?.useCaseId);
  const disableData= useSelector(
    (state) => state.PEBCommon?.disableData
  );
  const [loading, setLoading] = useState(false);
  const [pinUnpinIsClicked,setPinUnpinIsClicked] = useState(0);
  const [respondentFilterFlag, setRespondentFilterFlag] = useState(false);
  const [categoriesList, setCategoriesList] = useState();
  const [categoriesAPIData, setcategoriesAPIData] = useState();
  const [responseRowRecord, setResponseRowRecord] = useState();
  const [categoryName, setCategoryName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  //const [recordData, setRecordData] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [addAllToReportloading, setAddAllToReportLoading] = useState(false);
  const [callResponseDetails,setCallResponseDetails] = useState(false);
  const buttonsRef = useRef([]);
  const [apiCounter,setApiCounter] = useState(0);
  const [addAllPanelKey,setAddAllPanelKey] = useState(0);
  const [currentPanelKey,setCurrentPanelKey] = useState(0);

  const highlightRow = useSelector(
    (state) => state.PEBCommon?.highlightCardData
  );
  
  // ******POC TO HIGHLIGHT********//
  const [activeKeys, setActiveKeys] = useState([]);
  const [useCaseKey, setUseCaseKey] = useState(0);
  const updateTrigger = useRef(0); 
  const addAllQuesRef = useRef();
  const [addAllQues,setAddAllQues] = useState([]);
  const [addAllApiData , setAddAllApiData] = useState({});
  const addAllApiDataRef = useRef({});
  const categoryNameRef = useRef("");
  const [newCardsAddedLength,setNewCardsAddedLength] = useState(0);
  const [exceedCards,setExceedCards] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addAllquestionsClicked,setAddAllQuestionsClicked] = useState(false);
  const [isApiResponseReceived, setIsApiResponseReceived] = useState(false);  // Flag for API completion

  const [loadingTip,setLoadingTip] = useState("");
  const [isEmptyExportUrl,setIsEmptyExportUrl] = useState(false);

  const [quesInReport,setQuesInReport] = useState([]);

  // const [doubleClickCheck,setDoubleClickCheck] = useState(false);
  const addMultipleApiRunning = useRef(false);

  const addAllClicked = useSelector(
     (state) => state.PEBCommon?.addAllClicked
  );

  const addMultipleCardsApiRunning = useSelector(
    (state) => state.PEBCommon?.addMultipleCardsApiRunning

  );
  const addMultipleCardsApiRunningRef = useRef(addMultipleCardsApiRunning);
  useEffect(()=>{
    addMultipleCardsApiRunningRef.current = addMultipleCardsApiRunning;    
  },[addMultipleCardsApiRunning])


  function getCategoriesWithDistinctQuesIds(findingsReportState) {
  const { supporting_data } = findingsReportState;
  
  // Create a map to group by category and collect unique question IDs
  const categoryMap = new Map();
  
  supporting_data.forEach(item => {
    // Handle different data structures in your state
    let categoryName, quesId;
    
    if (item.supporting_data && Array.isArray(item.supporting_data)) {
      // Handle nested supporting_data structure
      item.supporting_data.forEach(subItem => {
        categoryName = subItem.category_name;
        quesId = subItem.ques_id;
        
        if (categoryName && quesId) {
          if (!categoryMap.has(categoryName)) {
            categoryMap.set(categoryName, new Set());
          }
          categoryMap.get(categoryName).add(quesId);
        }
      });
    } else if (item.supporting_data && typeof item.supporting_data === 'object') {
      // Handle single supporting_data object structure
      categoryName = item.supporting_data.category_name;
      quesId = item.supporting_data.ques_id;
      
      if (categoryName && quesId) {
        if (!categoryMap.has(categoryName)) {
          categoryMap.set(categoryName, new Set());
        }
        categoryMap.get(categoryName).add(quesId);
      }
    }
  });
  
  // Convert map to array format
  const result = Array.from(categoryMap.entries()).map(([category, quesIdsSet]) => ({
    category,
    questionIds: Array.from(quesIdsSet)
  }));
  
  return result;
}



  function getDistinctQuesIds(state) {
    const quesIds = new Set();
    
    // Check if supporting_data exists
    if (state.supporting_data) {
      state.supporting_data.forEach(card => {
        // Handle Type 1 cards (supporting_data is array)
        if (Array.isArray(card.supporting_data)) {
          card.supporting_data.forEach(item => {
            if (item.ques_id) {
              quesIds.add(item.ques_id);
            }
          });
        }
        // Handle Type 2 cards (supporting_data is object)
        else if (card.supporting_data && card.supporting_data.ques_id) {
          quesIds.add(card.supporting_data.ques_id);
        }
      });
    }    
    if (state.insight_list) {
      state.insight_list.forEach(data=>{
        data.questions_list.forEach(card => {
        // Handle Type 1 cards (insight_list is array)
        if (Array.isArray(card.supporting_data)) {
          card.supporting_data.forEach(item => {
            if (item.ques_id) {
              quesIds.add(item.ques_id);
            }
          });
        }
        // Handle Type 2 cards (supporting_data is object)
        else if (card.supporting_data && card.supporting_data.ques_id) {
          quesIds.add(card.supporting_data.ques_id);
        }
      });
      })
      
    }    
    
    return Array.from(quesIds);
  }


  const [hasCalled, setHasCalled] = useState(false);
  const hasCalledRef = useRef(false);

  const callPinApiForDataOnly=async(categoryName)=>{
    const useCaseId = getUseCaseIdByCategoryName(useCaseData, categoryName);
    let skipApiCall = false;

    // to skip extra api call on pin in usecase screen
    if(useCaseId==null && categoryName!="Pinned" && screenName=="View Use Case"){
      skipApiCall = true;
    }
    
    const payload = {
      user_id: userId,
      screen_name: "response_details",
      use_case_id:useCaseId,
      search_string: searchString || "",
      category_name: categoryName,
      analysis_id: localStorage.getItem("analysisId") || "",
      analysis_refresh_date: analysisData?.last_updated || "",
      ques_max_updated_ts: analysisData?.quesMaxUpdatedTs || "",
      allowed_geographies: userInfo?.allowed_geographies || [],
      allowed_indications:userInfo?.allowed_indications || [],
      comparator_data:
        filterData.length > 0
          ? filterData
          : [
              {
                age: null,
                race: null,
                gender: null,
                ethnicity: null,
                geography: null,
                indication: null,
                comparator_nm: "",
                origin_country: null,
                sub_indication: null,
                therapeutic_area: null,
              },
            ],
    };
    let response = {};
    if(!skipApiCall){
      response = await getQuestionsByCategory(payload);
    
      addPinnedCategory(catQuesMap.current, response?.result,categoryName);
     
    }
}

  const [catStatusTime,setCatStatusTime] = useState(4000);
  useEffect(() => {
    if(!IsReportOpen || addMultipleCardsApiRunning || addMultipleCardsApiRunningRef.current){
      return;
    }
    let pinnedAndOpenTextResponseReceived = sessionStorage.getItem("apiDataFetched");
    // Call only once when data is available and hasn't been called yet
    if (!hasCalled && 
      pinnedAndOpenTextResponseReceived!="true" &&
      pinnedAndOpenTextResponseReceived!=true && 
      filterData && filterData.length > 0) {
       
        callPinApiForDataOnly("Pinned",0);
        callPinApiForDataOnly("Open Text Response Questions",0);
        sessionStorage.setItem("apiDataFetched",true)
        setCatStatusTime(1000);
        setHasCalled(true);
        hasCalledRef.current = true;
    }
  }, [filterData, hasCalled]);

  const quesIdRef = useRef([]);
  const statusRefs = useRef({});
  // not in use now
  const catQuesMap = useRef([]);
  // used now with api
  const categoryStatusRef = useRef([]);
  const [categoryStatus,setCategoryStatus] = useState([]);
  

  useEffect(()=>{
    if(!IsReportOpen){
      return;
    }
    const arr = getDistinctQuesIds(findingsReport)
    quesIdRef.current = arr;
    const tempArr = getCategoriesWithDistinctQuesIds(findingsReport);
    setQuesInReport(arr);

    // preserving pinned 

    const existingPinnedCategory = catQuesMap.current.find(cat => cat.category === 'Pinned');

    // Update catQuesMap.current while preserving "Pinned"
    if (existingPinnedCategory) {
      // Remove "Pinned" from tempArr if it exists (to avoid duplicates)
      const tempArrWithoutPinned = tempArr.filter(cat => cat.category !== 'Pinned');
      
      // Combine existing pinned with new categories
      catQuesMap.current = [...tempArrWithoutPinned, existingPinnedCategory];
    } else {
      // If no existing pinned category, just use tempArr
      catQuesMap.current = tempArr;
    }

    // preserving pinned end


    setQuesInReport(prev => {
    if (JSON.stringify(prev) !== JSON.stringify(arr)) {
      return arr;
    }
    return [...arr]; // Force new reference

  });

    updateStatusElements();
    setTimeout(() => {
        updateStatusElements();

    }, 2000);


  },[findingsReport?.supporting_data])


  const updateStatusElements = () => {
  
  // Group all composite keys by record ID
  const recordGroups = {};
  Object.keys(statusRefs.current).forEach(compositeKey => {
    const recordId = compositeKey.split('-')[1];
    if (!recordGroups[recordId]) {
      recordGroups[recordId] = [];
    }
    recordGroups[recordId].push(compositeKey);
  });
  
  // Update all instances of each record
  
  Object.keys(recordGroups).forEach(recordId => {
    const isPresent = quesIdRef.current.includes(recordId);
    
    // Update all composite keys for this record ID
    recordGroups[recordId].forEach(compositeKey => {
      const statusEl = statusRefs.current[compositeKey];
      
      if (statusEl && IsReportOpen) {
        // Clear previous content and classes
        statusEl.innerHTML = '';
        statusEl.classList.remove('status-indicator', 'status-green', 'status-yellow', 'status-grey');
        
        // Add base class
        statusEl.classList.add('status-indicator');
        
        if (isPresent) {
          statusEl.classList.add('status-green');
          statusEl.innerHTML = '&nbsp;';
          statusEl.title = "Present in Export";
        } else {
          statusEl.classList.add('status-grey');
          statusEl.innerHTML = '&nbsp;';
          statusEl.title = "Not Present in Export";
        }
        
        statusEl.style.cursor = 'pointer';
        statusEl.style.padding = '2px';
      }
    });
  });
};


useEffect(() => {
  updateStatusElements();
  setTimeout(() => {
    updateStatusElements();
  }, 2000);
}, [quesInReport, pinUnpinIsClicked, counter]);


  const downloadOpenTextClicked=async(record)=>{
    // console.log("payload record",record);
    setLoading(true);
    setLoadingTip("Exporting OpenText responses.")
      // let offset = 0
      let sort_order = "ASC"
      let sort_column = "reason"
      let reason = [],
      preference = [],
      respondents = [],
      combined_indication =[],
      reasonValue=[]
      const payload = {
        user_id: userId,
        screen_name: "response_details",
        ques_id: record.id,
        reason:   reasonValue || [],
        preference: preference || [],
        respondents: respondents || [],
        combined_indication: combined_indication || [],
        sort_column,
        sort_order,
        comparator_data: filterData,
        analysis_id: localStorage.getItem("analysisId") || "",
        analysis_refresh_date: analysisData?.last_updated || "",
        ques_max_updated_ts: analysisData?.quesMaxUpdatedTs || "",
        limit: 100000,
        offset: 0,
        ques_type: record.ques_type,
        response_type: record?.responseType, 
        ques_text:record?.question,
        allowed_geographies: userInfo?.allowed_geographies || [],
        allowed_indications:userInfo?.allowed_indications || [],
        rank: []
      };
    let response = await downloadOpenTextResponses(payload);
    // console.log("payload resp",response);
      // setFlag(false);
      setLoadingTip("");
      setLoading(false);
    if(response?.export_url==""){
      setIsEmptyExportUrl(true);
      setTimeout(()=>{
        setIsEmptyExportUrl(false);
      },5000)
    }
    window.open(aesEncryt(response.export_url), "_parent");
   
  }

 
 // useEffect(()=>{
  //   console.log("mount");
  //   return()=>{
  //     console.log("unmount");
  //     // for managing loader on report
  // if we want to hide loading then enable this below
  //     // dispatch(setAddAllClicked(false));
  //     // setAddAllQuestionsClicked(false);
  //   }
  // },[])
 
  

 

 

  useEffect(()=>{
    
    // console.log("exceedCards",analysisData?.totalCards + newCardsAddedLength-MAX_ALLOWED_CARDS,isApiResponseReceived,exceedCards,totalNumberOfCardsRef);
      if(analysisData?.totalCards + newCardsAddedLength > MAX_ALLOWED_CARDS && addAllquestionsClicked && isApiResponseReceived){
        dispatch(setLoadingDisplayCategoryQuesData(false));
        setExceedCards((analysisData?.totalCards + newCardsAddedLength)-MAX_ALLOWED_CARDS);
        dispatch(setExceedingCardsInReport((analysisData?.totalCards + newCardsAddedLength)-MAX_ALLOWED_CARDS))
        dispatch(setAddAllClicked(false));
        // setIsModalOpen(true);
        setAddAllQuestionsClicked(false);
      }
  },[apiCounter,exceedCards])

  useEffect(()=>{
    
    
   
    const isEmpty = Object.keys(addAllApiData).length === 0;
   
    // console.log("...........................hulk .........................");
    // console.log("hulk isempty",!isEmpty);
    // console.log("hulk quesMaxUpdatedTs",analysisData?.quesMaxUpdatedTs);
    // console.log("hulk addAllquestionsClicked",addAllquestionsClicked);
    // console.log("hulk isApiResponseReceived",isApiResponseReceived);
    // console.log("hulk addMultipleCardsApiRunning",!addMultipleCardsApiRunning);
    
    
    
    
   

    if(analysisData?.totalCards + newCardsAddedLength > MAX_ALLOWED_CARDS && addAllquestionsClicked ){
      dispatch(setLoadingDisplayCategoryQuesData(false));

     
    }
    
    else if (!isEmpty && analysisData?.quesMaxUpdatedTs && 
      addAllquestionsClicked && 
      isApiResponseReceived 
      // && !addMultipleApiRunning.current
      && !addMultipleCardsApiRunning
      
    ) {
      // setTimeout(() => {
        // setDoubleClickCheck(false);
        addMultipleCardsFunction();

        dispatch(setAddMultipleCardsApiRunning(true));

      // }, 5000);
    }
   

  

  },[addAllApiData,
    apiCounter,
    // activeKeys
    addAllquestionsClicked
  ])


  const addMultipleCardsFunction = async()=>{
    let quesData = {};
    dispatch(setLoadingDisplayCategoryQuesData(false));

  //  console.log("hulk addAll",addAllApiDataRef);
  //  console.log("hulk category ref",categoryNameRef.current);
  //  console.log("hulk category",categoryName); 
  //  console.log("hulk currentPanelKey",currentPanelKey);
  //  console.log("hulk addAllPanelKey",addAllPanelKey);
   
   
  //  console.log("hulk new cat",categoriesList[Number(addAllPanelKey[0])-1]?.category_name);
   
   
   
    quesData[categoriesList[Number(addAllPanelKey[0])-1]?.category_name] = addAllApiDataRef.current[categoriesList[Number(addAllPanelKey[0])-1]?.category_name];

    Object.keys(quesData)?.forEach(category => {
      quesData[category]?.forEach(item => {
        item.ques_max_updated_ts = analysisData?.quesMaxUpdatedTs || "";
            });
    });
    const allQuestions = Object.values(quesData).flat();
    

    const payload = {
      
        user_id: userId,
        screen_name: "response_details",
        category_name: categoriesList[Number(addAllPanelKey[0])-1]?.category_name,
        supp_card_order:analysisData?.totalCards+1||1,
        // check
        // panel_key:activeKeys[0],
        // 
        panel_key:addAllPanelKey[0],
        analysis_id: localStorage.getItem("analysisId") || "",
        analysis_refresh_date: analysisData?.last_updated || "",
        ques_details_list:allQuestions,
        allowed_geographies: userInfo?.allowed_geographies || [],
        allowed_indications:userInfo?.allowed_indications || [],
        comparator_data:
          filterData.length > 0
            ? filterData
            : [
                {
                  age: null,
                  race: null,
                  gender: null,
                  ethnicity: null,
                  geography: null,
                  indication: null,
                  comparator_nm: "",
                  origin_country: null,
                  sub_indication: null,
                  therapeutic_area: null,
                },
              ],
      };
     
    let response = {};
    if(allQuestions && allQuestions[0]!=undefined){
      response = await addMultipleCards(payload);
      // console.log("addAllApiData resp",response);
      // dispatch(setAddAllClicked(false));
      // "message": "Background Task Started",
      // "bground_task_id": "b3cc1f1c-e3db-4fa5-a3d4-03df078ff5cf"
      let backgroundTaskId = response?.bground_task_id || "";

      const payload2 = {
        user_id: userId,
        bground_task_id :backgroundTaskId
      }
      // console.log("result setting empty");
      
      // setAddAllApiData({});
      checkStatusUntilSuccess(payload2);
    }
    else if(allQuestions?.length==0 && allQuestions[0]==undefined){
        setTimeout(() => {
          


          dispatch(setAddAllClicked(false));
          setAddAllQuestionsClicked(false);
          dispatch(setAddMultipleCardsApiRunning(false));
          setAddAllApiData({});
          addAllApiDataRef.current={};
          setIsApiResponseReceived(false);
          addMultipleApiRunning.current = false;
          dispatch(
            setNotificationData({
              type: NotificationTypes.ERROR,
              duration:10,
              message: (
                <>
                  <strong>These questions can't be added to export.  </strong> 
                  <br/>
                  Try searching with different keywords.
                </>
              ),
            })
          );





        }, 1000);
        

    }
      
    
    // addAllApiDataRef.current={};
    

   
    // backgroundTaskId?.length>0 && 
    
    // backgroundTaskId="";
    
  }

  const checkStatusUntilSuccess = async (payload2) => {
    let success = false;
    addMultipleApiRunning.current = true;
    // dispatch(setAddMultipleCardsApiRunning(true));
  
    while (!success) {
      let finalResponse = await checkAsyncStatus(payload2);
      
      if (finalResponse.bground_task_status === 'Completed' || finalResponse.bground_task_status ==='Failed') {
        // console.log("Success:", finalResponse);
        success = true;  // Set success to true to stop the loop
        setTimeout(() => {
          dispatch(setAsyncApiResponse(true));
        }, 2000);
        dispatch(setAddAllClicked(false));
        setAddAllQuestionsClicked(false);
        // make this dispatch out using useffect
        // setTimeout(() => {
        //   dispatch(
        //     setNotificationData({
        //       type: NotificationTypes.SUCCESS,
        //       message: (
        //         <>
        //           <strong>Process Completed: </strong> 
        //           {/* <br/> */}
        //           {` ${totalCardsInReport} ... ${totalCardsInReportRef.current} ... ${totalNumberOfCards.length} ...${totalNumberOfCardsRef.current} Total Cards Added to Export - ${analysisData?.totalCards + newCardsAddedLength}/${MAX_ALLOWED_CARDS}`}
        //         </>
        //       ),
        //     })
        //   );
        // }, 2000);

       
       
        
              // console.log("result setting empty 2");
              
        setAddAllApiData({});
        addAllApiDataRef.current={};
        setIsApiResponseReceived(false);
        addMultipleApiRunning.current = false;
        dispatch(setAddMultipleCardsApiRunning(false));

      } else {
        // console.log("Not successful, retrying...");
        // Wait for 5 seconds before retrying
        await new Promise(resolve => setTimeout(resolve, 5000));
      }
    }
  };


  

  const handleSubmitCheckbox=(e,item,index)=>{
    dispatch(setMinimizedOpenedReport(false));
    if(addMultipleCardsApiRunning){
      return;
    }
    dispatch(setAsyncApiResponse(false));

    // setAsyncApiResponse(false);
    // setAddAllQues(["temp"]);
    // console.log(
    //   "handleSubmitCheckbox target",e.target
    // );
    // console.log("handleSubmitCheckbox item",item);
    // console.log("handleSubmitCheckbox index",index);
    categoryNameRef.current=item?.category_name;
    dispatch(setLoadingDisplayCategoryQuesData(true));
    setIsApiResponseReceived(false);
    // setActiveKeys([]);


    // console.log("handleSubmitCheckbox",index);
    // console.log("handleSubmitCheckbox",item);
    
    
    dispatch(setAddAllClicked(true));
    setAddAllQuestionsClicked(true);
    // setDoubleClickCheck(true);
    // setActiveKeys([index+1]);
    // setAddAllPanelKey((prev)=>[prev , ...[(index+1).toString()]]);
    // YS obs we can try making this sync with activekey if length is decreasing from 2 or more to 0
    // then capture it in state so that we can open dropdown later
    setAddAllPanelKey([(index+1).toString()]);
   
    // console.log("submit data",apiResponse.current );
    // onChange(['5']);
    // onChange(['5']);
    // getCategoriesForResponses();
    // setTimeout(()=>{
    //   setAddAllQues([]);
    //   onChange([]);
    //   setAddAllQues([]);

    //   // getCategoriesForResponses();

    //   addAllQuesRef.current = [];
    //   console.log("ey = addAllQuesRef.current",addAllQuesRef.current);
    //   setAddAllQuestionsClicked(false);
    // },10000)

    // setAddAllQues([]);

    
    
    
  }
  const processQuestionData = async(data,categoryName) => {
    // console.log("thor ironData",data);
    
    
    // const result = {};
    
    // console.log("addAllApiData",addAllApiData);
    
    const result = addAllApiDataRef.current;
    // console.log("result",result);
    
  
    data && Object.keys(data).length > 0 && data?.forEach((question) => {
      const { ques_category_name, ques_id, response_type, ques_type,criteria_details } = question;
      
      // If the category doesn't exist in the result, initialize it as an empty array
      if (!result[categoryName]) {
        result[categoryName] = [];
      }
      // basically we r passing if criteria count is 0 and respondent count also 0 
      // as we have put condition for greater than or equal to 
      // this is 1 special case
      const emptyCriteria = criteria_details[0]?.details.length==0 && respondentsCount ==0?true:false;    
  
      // Check if the question is already in the list for the category to avoid duplicates
      const existingQuestion = result[categoryName].find(q => q.question_id === ques_id);      
      if (!existingQuestion && response_type!="Grid" && response_type!="Open" && (criteria_details[0]?.details[0]?.n_size >= respondentsCount || emptyCriteria) ) {
        // If question doesn't exist, add it to the category
        result[categoryName].push({
          question_id: ques_id,
          response_type: response_type,
          ques_type: ques_type
        });
      }
    });
  
    // console.log("irondata result",result);
    
    return result;
  };

  const handleAllCards=(index)=>{
    setAddAllToReportLoading(true);
    setCallResponseDetails(true);
    const button = buttonsRef.current[index];
    if(button!=null){
      button.click();
    }
  }
  // const [rowToHighLight, setRowToHighLight] = useState();
  const groupDataByIndication = (criteriaData) => {
    const groupedData = [];

    // Iterate over each criterion (e.g., Criteria 10, Criteria 20)
    Object.keys(criteriaData).forEach((criteria) => {
      // Group the data for each combined indication
      const combinedIndicationGroups = {};

      criteriaData[criteria].forEach((item) => {
        const { combined_indication } = item;

        // Group by combined_indication
        if (!combinedIndicationGroups[combined_indication]) {
          combinedIndicationGroups[combined_indication] = [];
        }

        combinedIndicationGroups[combined_indication].push(item);
      });

      // Now, push the grouped data into the result array
      Object.keys(combinedIndicationGroups).forEach((combinedIndication) => {
        groupedData.push({
          [criteria]: combinedIndicationGroups[combinedIndication],
        });
      });
    });

    return groupedData;
  };

  const columns = [
    {
      title: "Questions",
      dataIndex: "question",
      key: "question",
      maxWidth: "10vw",
      width: "10vw",
      fixed: "left",
      render: (text,record) => {
      return (
      <div>
      {text}
      { record?.ques_info &&
      <Tooltip
        title={
          <div style={{ maxWidth: 300, whiteSpace: 'pre-wrap' }}>
            {record?.ques_info}
          </div>
        }
      >
        <InfoCircleOutlined
          style={{
            marginLeft: 6,
            color: '#1890ff',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        />
      </Tooltip>}
      <br />
      
      <strong style={{ fontStyle: 'italic', marginRight:'5px' }}>({record?.id})</strong>
        <div 
          style={{
            // display: 'inline-block',
            fontSize: '12px',
            cursor: 'pointer',
            padding: '2px',
            minHeight: '18px',
            minWidth: '18px'
          }}
        ref={el => {
        if (el && IsReportOpen) {
          const isPresent = quesIdRef.current.includes(record?.id);
          
          // Function to update element styling
          const updateElementStyle = (element) => {
            element.innerHTML = '';
            element.classList.remove('status-indicator', 'status-green', 'status-yellow', 'status-grey');
            element.classList.add('status-indicator');

            if (isPresent) {
              element.classList.add('status-green');
              element.innerHTML = '&nbsp;';
              element.title = "Present in Export";
            } else {
              element.classList.add('status-grey');
              element.innerHTML = '&nbsp;';
              element.title = "Not Present in Export";
            }
          };
    
        // Set the appropriate composite key based on context
        let compositeKey;
        
        // Check if this is being rendered in the pinned section
        // need to pass this info or detect it somehow
       
        let panelKey = Number(record?.panelKey);
        let category = categoriesList?.filter((item,index)=>
            item?.key==panelKey
        )[0]?.category_name
        
        // basically whenever category opens we r saving
        // it's refference of div in statusRef
       
        if(category=="Open Text Response Questions"){
          compositeKey = `Open Text Response Questions-${record?.id}`;
        }
        else if(category=="Pinned"){
          compositeKey = `Pinned-${record?.id}`;
          statusRefs.current[compositeKey] = el;
        } 
        else {
          compositeKey = `${record?.categoryName}-${record?.id}`;
          statusRefs.current[compositeKey] = el;
        }
        
        statusRefs.current[compositeKey] = el;
        updateElementStyle(el);
      }
    }}



    />
    </div>
      
    )
    },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      // maxWidth: "6vw",
      width: 70,
      render: (_, record,i) => {
        
        let nSizeArray = record.n_size.flat();
       
        const isEmptyQuestion = nSizeArray.every((data)=>(
          data==null || data==undefined || data==0 || data=="null" || data=="undefined"
        ))
        
        let tooltipTopLine = "";        
        let category = record?.opened_category_name;
      
        let tooltipBottom = "";
        if(record.responseType=='Open'){
          tooltipTopLine = "Use 'View More Responses' to add to export ";
          tooltipBottom = "for this type of question.";
        }
        if(record.responseType=='Grid'){
          tooltipTopLine = "Use 'View More Responses' to add co-morbidities of  your";
          tooltipBottom = "interest to export for this type of question."
        }
        if(record.nSize==0 || isEmptyQuestion){
          tooltipTopLine = "No responses available"
          tooltipBottom= "to add to the export."
        }
        return(
        <Space size="small" style={{ display: "inline-block" }}>
          {!record.addToFindingsFlag || addMultipleCardsApiRunning || respondentsCount > record?.n_size[0]   ? (
            <Tooltip
              title={
                addMultipleCardsApiRunning?(
                <div>
                  Addition to Export is in <br />
                  progress. Please wait
                </div>
                ):(
                <div>
                  Create or open a export in <br />
                  order to Add to Findings
                </div>)
              }>
              <Space>
                <img
                  alt={"Build/Update Export"}
                  src={AddToFindingsDisabledIcon}
                />
                <span style={{ color: "#B2B0B6" }}>Add Top Responses</span>
              </Space>
              <Space>
                <img
                  alt={"Build/Update Export"}
                  style={{ cursor: "pointer" }}
                  src={AddToFindingsDisabledIcon}
                />
                <span style={{ color:"#B2B0B6"}}>Add All Responses </span>
            </Space>
            </Tooltip>
          ) : (
            <>
            <Space>
              <img
                alt={"Build/Update Export"}
                style={{ cursor: "pointer" }}
                src={AddToFindingsIcon}
                onClick={() => addToFindingsModal(record)}
              />
              <span style={{ color: "#2F6F7B" }}>Add Top Responses</span>
            </Space>
            {(record.responseType=='Open' || record.responseType=='Grid' || record.nSize==0 || isEmptyQuestion)?(
              <Tooltip title={
                <div>
                 {tooltipTopLine}<br />{tooltipBottom} 
                  
                </div>}>
              <Space>
            <img
              alt={"Build/Update Export"}
              style={{ cursor: "pointer" }}
              src={AddToFindingsDisabledIcon}
            />
            <span style={{ color:"#B2B0B6"}}>Add All Responses </span>
          </Space>
          </Tooltip>
          ):(
              <Space>
            <img
              alt={"Build/Update Export"}
              style={{ cursor: "pointer" }}
              src={AddToFindingsIcon}
              onClick={()=>handleAllCards(i)}
            />
            <span style={{ color:"#2F6F7B"}}>Add All Responses </span>
          </Space>
          )
          }
          </>
          )}
           <Tooltip title={
                <div>
                Download Open Text Responses
                  
                </div>}>
          <Space>
            {(category=="Open Text Response Questions")?(
              <>
              <Button
              style={{ width: 20 , height:30,marginBottom:5}}
              icon={<DownloadOutlined />}
              onClick={() => downloadOpenTextClicked(record)}
            ></Button>
              <span style={{ color:"#2F6F7B"}}>Download Responses </span>
            </>
            ):(<></>)
              }
            </Space>

            </Tooltip>
          {record.pinnedFlag ? (
            <Space>
              <img
                style={{ cursor: "pointer" , pointerEvents: 'auto' }}
                alt={"UnPin Question"}
                src={PinnedIcon}
                onClick={() => pinUnpinQuestionClicked(record, "unpin",category)}
              />
              <span style={{ color: "#2F6F7B" }}>Pinned</span>
            </Space>
          ) : (
            <Space>
              <img
                style={{ cursor: "pointer",pointerEvents: 'auto' }}
                alt={"Pin Question"}
                src={UnpinIcon}
                onClick={() => pinUnpinQuestionClicked(record, "pin",category)}
              />
              <span style={{ color: "#2F6F7B" }}> Pin</span>
            </Space>
          )}
        </Space>
      )},
    },
  ];
  //const [supportingData, setSupportingData] = useState([]);
  // const isOpen = useSelector((state)=>state.PEBCommon.findingsReport.isOpen)
  const addToFindingsModal = (inputJSON) => {

    // dispatch(setExceedingCardsInReport(exceedingCardsInReport+1));
 if( totalNumberOfCardsRef.current + 1 > MAX_ALLOWED_CARDS){
      setAddAllToReportLoading(false);
      // setIsModalOpen(true);
      // setExceedCards(totalNumberOfCardsRef.current + dataArraySize - MAX_ALLOWED_CARDS);
      dispatch(setExceedingCardsInReport(totalNumberOfCardsRef.current + 1 - MAX_ALLOWED_CARDS));
      return;
    }

    setLoading(true);
    let analysis_id = localStorage.getItem("analysisId");
    const {
      question,
      id,
      responseType,
      pinnedFlag,
      categoryName,
      n_size,
      nSize,
      addToFindingsFlag,
      viewAllResponseFlag,
      panelKey,
      ques_type,
      ques_info,
      opened_category_name,
      ...criteria
    } = inputJSON;

    function transformJSON() {
      
    const newCriteria  = groupDataByIndication(criteria);
    let transformedData = [];
    let temp = [];
    let finalArray = [];

        transformedData = Object.keys(criteria).map((criteriaName) => {
          
          const criteriaInfo = criteria[criteriaName];
          const criteriaResponses =
            // Array.isArray(criteriaInfo)  ?
            criteriaInfo.map((response) => ({
              response: responseType === 'Grid' ? `${response.response} - ${response.combined_indication}` : response.response,
              perc_respondents: response.perc_respondents,
              nSize: response.n_size,
              hover_string: response.hover_string,
            }));
  
          
         
  
          return {
            criteria_name: criteriaName,
            nSize: criteria[criteriaName]?.n_size,
            details: criteriaResponses,
          };
        });

      responseType === 'Grid' && newCriteria.forEach((item,i)=>{
        temp = Object.keys(item).map((criteriaName) => {
          
          const criteriaInfo = item[criteriaName];
          const criteriaResponses =
            // Array.isArray(criteriaInfo)  ?
            criteriaInfo.map((response) => ({
              response: responseType === 'Grid' ? `${response.response} - ${response.combined_indication}` : response.response,
              perc_respondents: response.perc_respondents,
              nSize: response.n_size,
              hover_string: response.hover_string,
            }));          
         
  
          return {
            criteria_name: criteriaName,
            nSize: criteria[criteriaName]?.n_size,
            details: criteriaResponses,
          };
        });
        finalArray.push(...temp);
      })

      

      return {
        ques_text: question,
        ques_id: id,
        response_type: responseType,
        criteria_details: finalArray?.length!=0?finalArray:transformedData,
        category_name: categoryName,
        panel_key: pinnedFlag ? "1" : panelKey,
      };
    }
    const result = transformJSON(inputJSON);
    const addSupportingData = async (suppCardOrder) => {
      const payload = {
        user_id: userId,
        analysis_id: analysis_id,
        save_type: "supp_ques",
        order_data: {},
        prev_insight_id: "",
        insight_id: "",
        edit_insight_flag: false,
        insight_text: "",
        ques_id: result.ques_id,
        insight_order: 2,
        ques_order: 1,
        insight_ques_order: 0,
        supporting_data: JSON.stringify(result),
        preference: "",
        reason: "",
        supp_card_id: "",
        supp_card_order: +suppCardOrder + 1,
        added_from: "category_responses",
        combined_indication:"",
      };
      let response = await saveFindingsReportData(payload);
      return response;
    };
    if (analysis_id != null) {
      let suppCardOrder = localStorage.getItem("suppCardOrder");

      addSupportingData(suppCardOrder).then((data) => {
        setLoading(false);

        dispatch(
          setFindingsReportAddSupportingData({
            data: {
              supp_card_id: data.result.supp_card_id,
              ques_order: data.result.max_supp_card_order,
              supp_card_order: +suppCardOrder + 1,
              ques_id: result.ques_id,
              supporting_data: result,
            },
          })
        );
        localStorage.setItem("suppCardOrder", data.result.max_supp_card_order);

        // commenting for dropdown close issue on addtoReport after pin/unpin
        // onChange([panelKey]);
      });
    }
    dispatch(setRecordData(inputJSON));
  };

  const responseDetailDrawer = (state, row,index) => {
    // console.log("hulk.......................",index);
    setCurrentPanelKey(index);
    setCategoryName(row?.categoryName);

    setRespondentFilterFlag(state);
    setResponseRowRecord(row);
  };

  const truncateText = (text, maxLength) => {
    if (!text) return ''; // Handle the case where text might be undefined or null
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + '...';
  };

  const buildOutput = (quesList, categoryName, panelKey, scroll) => {
    let result = quesList;
    let resType = '' ;
    const finalData = [];
    const columns1 = [];
    let xWidth = 800;
   result.forEach((item1) => {
    let item = item1;
    // console.log("n = item",item1);
    // console.log("n = filterData",filterData);
 
    
// commented for N = , bug
    const comparatorNames = filterData
    .map(item => item.comparator_nm)
    // .sort();  // Sorting ensures the correct order

// Step 2: Add missing criteria names from comparatorNames
comparatorNames.forEach(criteriaName => {
    // Check if the criteria name already exists in data.criteria_details
    const criteriaExists = item.criteria_details.some(tempitem => tempitem.criteria_name === criteriaName);
    
    if (!criteriaExists) {
        // Add missing criteria with empty details
        item.criteria_details.push({
            criteria_name: criteriaName,
            details: [] // Empty details
        });
    }
});

// console.log("n = myitem",item);

// Step 3: Sort the data.criteria_details to match the comparatorNames order
item.criteria_details.sort((a, b) => {
    const indexA = comparatorNames.indexOf(a.criteria_name);
    const indexB = comparatorNames.indexOf(b.criteria_name);
    return indexA - indexB;
});



// console.log("n = item final",item);










     resType =item.response_type;
     const result1 = {};
     let resSize = { nSize: [] };
    //  console.log(item.criteria_details);
     item.criteria_details.forEach((item1) => {
      // console.log("item1",item1);
      
       const { criteria_name, details } = item1;
       result1[criteria_name] = details;
        // console.log("n = details",details);
        
      //  console.log("item1.details ", item.response_type ,item1.details);
      //  resSize = {
      //    nSize: item1.details.n_size && item.response_type !== 'Grid'
      //      ? item1.details[0].n_size
      //      : item1.details
      //          .map((item) => item.n_size) // Extract n_size values
      //          .filter((nSize) => nSize !== undefined), // Filter out undefined values
      //  };
      let temp;
      if (resType === 'Grid') {
        // If Grid, store all nSize values
        temp = details
          .map((detail) => detail.n_size)
          .filter((nSize) => nSize !== undefined); // Get all valid nSize values
        resSize.nSize.push(temp);
      } else {
        // If not Grid, store only the first element's nSize
        // change this
        // fetch criteria number from above using gpt
        // then add -1 for all which have nsize 0 or don't exost
        // then indexing should work
        temp = [details[0]?.n_size] || [0];
        // resSize.nSize.push(...temp);
        resSize.nSize.push(temp);
      }
     });
     let obj1 = {
       question: item.ques_text,
      //  question:<div>
      //   {item.ques_text}
      //   <br></br>
      //   <strong>({item.ques_id})</strong>
      //  </div>,
       id: item.ques_id,
       n_size: resSize.nSize,
       responseType: item.response_type,
       pinnedFlag: item.pinned_flag,
       categoryName: item.ques_category_name,
       viewAllResponseFlag: item.hide_response_details_flag,
       panelKey: panelKey,
       addToFindingsFlag: disableData,
       ques_type: item.ques_type,
       ques_info:item?.ques_info,
       opened_category_name:item?.opened_category_name
     };
     let obj = {};
     if (item.criteria_details.length > 1) {
       obj = { ...obj1, ...result1 };
     } else {
       obj = { ...obj1, ...result1, ...resSize };
     }
     finalData.push(obj);
   });

   setDataSource(finalData);   

   filterAppliedData.forEach((item, index) => {
    // let check = {};
    // // console.log("item",item);
    
    // if(index==0){

    
    // check = {  
      
    //   dataIndex: "nSize",
    //   // key:`${checkedList.length + count + checkedListRef.current.length + Math.random()}`,
    //   // width: 100,
    //   maxWidth: "10vw",
    //   width: "10vw",
    //   fixed: "left",
    //   render: (text,record,i) => (
    //     <>
    //     {console.log("qrecord",record)
    //     }
    //     {/* {
    //       addAllQuesRef.current.push(record?.id)
    //     } */}
       
        
           

             
    //           {/* <button  key={(Math.random() + 1).toString(36).substring(7)} onClick={()=>setCount((prev)=>prev+1)}>check{count}</button> */}




    //     </>
    //   ),
    // };
    // }
    // // setAddAllQues(addAllQuesRef.current);


    // // xWidth = 1100;
    // index==0 && columns1.push(check);
     const obj = {
       title: filterData.length > 1 ? item.comparator_name : "Responses",
       dataIndex: item.comparator_name,
       key: index + 1,
       width: 160,
       render: (_, record,objindex) => {  
        return(
         <Space size="small" key={objindex}>
           {
             <div>
               {record[item.comparator_name]?.map((obj) => 
                 (obj?.response !== "Open text" ? (<div>
                   <Tooltip
                     title={`${obj?.hover_string} of ${obj?.n_size} Respondents`}>
                     <div
                       style={{
                         fontSize: 20,
                         fontWeight: 700,
                         cursor: "pointer",
                         width:54,
                         display:"inline-flex"
                       }}>
                       {obj?.perc_respondents}%
                     </div>
                   </Tooltip>
                   <div
                     style={{
                       fontSize: 14,
                       fontWeight: 400,
                       marginLeft: 10,
                       width: obj?.combined_indication ? "" : 200,
                       display: "inline-flex",
                     }}>
                     {obj?.response}
                   </div>
                   {obj?.combined_indication && (
                     <Tooltip title={obj?.combined_indication}>
                       <span
                         style={{
                           fontSize: 16,
                           fontWeight: 700,
                           cursor: "pointer",
                         }}>
                         {" - " + truncateText(obj?.combined_indication, 20)}
                       </span>
                     </Tooltip>
                   )}
                 </div>): <Tooltip
                     title={`${obj?.n_size} Respondents`}>
                     <div  style={{
                       fontSize: 16,
                       fontWeight: 400,
                       display: "inline-flex",
                     }}>Open text responses</div>
                   </Tooltip>)
               )}
               {record[item.comparator_name] &&
                 !record?.viewAllResponseFlag && (
                   <div style={{ marginTop: 12 }}>
                    <div className="view-response-anchor" style={{ display:'flex' , fontStyle:'italic' }}>
                    
                    
                    {record?.n_size[index][0]!=undefined && 
                    (<strong style={{display:'flex'}}>(&nbsp;N = &nbsp; {record && record?.n_size[index]?.map((obj,i)=><div style={{marginBottom:'1rem' , display:'flex'}}>{obj}{i+1==record?.n_size[index]?.length?"":","} </div>)}&nbsp;)</strong>)
                    }
                    
                    
                    
                    </div>
                    {record?.n_size[index][0]!=undefined && (
                      <>
                     <a
                       className="view-response-anchor"
                       onClick={() => responseDetailDrawer(true, record,record?.panelKey)}>
                       View All Responses
                     </a>
                     <a
                        style={{visibility:"hidden"}}
                        ref={(el) => (buttonsRef.current[objindex] = el)}
                        className="view-response-anchor"
                        onClick={() => responseDetailDrawer(false, record,record?.panelKey)}>
                          hidden button
                     </a>
                     </>
                      )}
                   </div>
                 )}
             </div>
             // }
             // </div>
           }
         </Space>
       )},
     };
     columns1.push(obj);
    
    //  console.log("filterAppliedData",filterAppliedData);
    // console.log("YS item",item);
    
     //  have to change logic , add data in new array and then iterate
    // as grid is looping though map currently
    // have to make 2d array.

    // change this condition accordingly to big number or remove it
    //  if (filterAppliedData.length < quesList) {
       const obj2 = {
         title: "N-Size",
         dataIndex: "nSize",
         key: "nSize",
         width: 50,
         render: (text,record,i) => (
           <>
           {/* {console.log("YS text ---", text )} */}
           {/* {console.log("YS record",record)
              
           } */}
           
           {/* { console.log("YS index",index)} */}
           {/* old line */}
           {/* {text && text.map((obj)=><div style={{marginBottom:'1rem'}}>{obj}</div>)} */}
           {record && record?.n_size[index].map((obj)=><div style={{marginBottom:'1rem'}}>{obj}</div>)}
           {/* {resType === 'Grid' ? (record[item.comparator_name]?.map((obj) => (
               <div
                 style={{
                   display: "flex",
                   alignItems: "",
                   minHeight:
                     record[item.comparator_name].length === 3
                       ? "2rem"
                       : "4rem",
                 }}>
                 {obj.n_size}
               </div>
             ))) : (<div>{record[item.comparator_name] && record[item.comparator_name][0]?.n_size}</div>)} */}
             
           </>
         ),
       };
       // xWidth = 1100;
      //  columns1.push(obj2);
    //  }
   });
    let analysis = localStorage.getItem("analysisId") || null;
    xWidth = analysis
      ? result[0].criteria_details.length > 3
        ? result[0].criteria_details.length * 450
        : result[0].criteria_details.length * 500
      : result[0].criteria_details.length * 420;

    const colObj = [...columns];
    colObj.splice(1, 0, ...columns1);

    // First, add this CSS to your component or CSS file
    // Updated styles for filtered row with dimmed content
   // Updated styles for filtered row with less dimming
    const tableStyles = `
      .filtered-row {
        background-color: #f8f8f8 !important; /* Light grey background */
        opacity: 0.7 !important; /* Less dimmed opacity */
        // pointer-events: none !important; /* Disable interactions */
      }

      .filtered-row:hover {
        background-color: #f0f0f0 !important; /* Slightly darker grey on hover */
        opacity: 0.8 !important; /* Slightly less dimmed on hover */
      }

      .filtered-row td {
        background-color: transparent !important;
        color: #777777 !important; /* Darker grey text */
      }

      .filtered-row .ant-tooltip {
        opacity: 0.7 !important; /* Less dimmed tooltips */
      }

      .filtered-row .view-response-anchor {
        color: #999999 !important; /* Less dimmed links */
        cursor: not-allowed !important; /* Show not-allowed cursor */
      }

      .filtered-row .ant-space {
        opacity: 0.8 !important; /* Less dimming for content */
      }

      /* Less dimmed percentage values */
      .filtered-row div[style*="fontSize: 20"] {
        color: #888888 !important;
        opacity: 0.8 !important;
      }

      /* Less dimmed response text */
      .filtered-row div[style*="fontSize: 14"] {
        color: #666666 !important;
        opacity: 0.8 !important;
      }
    `;



    // Add the styles to your component
    const StyleSheet = () => (
      <style>{tableStyles}</style>
    );
    // greying out in same table code

    //    let catList = categoriesList;
    // catList.forEach((item) => {
    //   if (item.category_name === categoryName) {
    //     item.children = (
    //       <div>
    //         <StyleSheet />
    //         <Table
    //           className="question-list-table"
    //           // rowClassName={(record) => ${record.id}}
    //           rowClassName={(record, index) => {
    //           // Check your condition here - when index is 0 and respondentsCount condition is met
    //           if (respondentsCount > record?.n_size[0]) {
    //             return 'filtered-row';
    //           }
    //           return '';
    //          }}
    //           dataSource={finalData}
    //           columns={colObj}
    //           pagination={false}
    //           scroll={{
    //             x: xWidth,
    //             y: 400,
    //           }}
    //         />
    //       </div>
    //     );
    //   }
    // });
    // setCategoriesList(catList);


    //setColumns(colObj);

    // setCategoryItems(categoriesList)
    const SimpleExpandableSection = ({ finalData, colObj, xWidth, respondentsCount }) => {
    const [showFiltered, setShowFiltered] = useState(false);

    // Separate data
    const normalData = finalData.filter(record => !(respondentsCount > record?.n_size[0]));
    const filteredData = finalData.filter(record => respondentsCount > record?.n_size[0]);




    return (
      <div>
        <StyleSheet />
        
        {/* Normal items table */}
        <Table
          className="question-list-table"
          dataSource={normalData}
          columns={colObj}
          pagination={false}
              key={`table-${counter}-${quesInReport.length}`}
          scroll={{
            x: xWidth,
            y: 400,
          }}
        />

        {/* Filtered items expandable section */}
        {filteredData.length > 0 && (
          <div style={{ marginTop: '16px', borderTop: '1px solid #e8e8e8', paddingTop: '16px' }}>
            <Button
              type="text"
              icon={showFiltered ? <MinusCircleOutlined /> : <PlusCircleOutlined /> }
              onClick={() => setShowFiltered(!showFiltered)}
              style={{ 
                padding: '4px 8px', 
                height: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: '#666',
                fontSize: '14px',
                marginInlineStart:'7px',
              }}
            >
              Questions with Response Count less than {respondentsCount}
              <Badge 
                count={filteredData.length} 
                style={{ 
                  backgroundColor: '#f0f0f0', 
                  color: '#666',
                  boxShadow: 'none',
                  border: '1px solid #d9d9d9',
                  marginLeft: '8px'
                }} 
              />
            </Button>

            {showFiltered && (
              <div style={{ marginTop: '12px', cursor: 'not-allowed' }}>
                <Table
                  style={{ pointerEvents: 'none' }}
                  className="question-list-table"
                  rowClassName={() => 'filtered-row'}
                  dataSource={filteredData}
                  columns={colObj}
                  pagination={false}
                  scroll={{
                    x: xWidth,
                    y: 300,
                  }}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

// Usage in your category list
    let catList = categoriesList;
    catList.forEach((item) => {
      if (item.category_name === categoryName) {
        item.children = (
          <SimpleExpandableSection 
            finalData={finalData}
            colObj={colObj}
            xWidth={xWidth}
            respondentsCount={respondentsCount}
          />
        );
      }
    });
    setCategoriesList(catList);

    if (scroll) {
      const intervalId = setInterval(() => {
        const element = document.getElementsByClassName(highlightRow.ques_id);

        if (element.length > 0) {
          setTimeout(() => {
            element[0]?.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
            element[0].classList.toggle("row-highlight");
            setTimeout(() => {
              element[0].classList.toggle("row-highlight");
              dispatch(setHighlightCardData({}));
            }, 5000);
          }, 100);
          clearInterval(intervalId);
        }
      }, 100);
    }
    // dispatch(setHighlightCardData(null));
  };

  const onChange = (key, scroll,updateAllDropdowns=false) => {
    setLoading(true);
    
    // if(key.length<activeKeys.length){
    //   // close
    //   setIsApiResponseReceived(true);
    // }
    // else{
    //   setIsApiResponseReceived(false);

    // }
    
    setActiveKeys(key);
    setApiCounter((prev)=>prev+1);
    // addAllQuesRef.current = [];
    // setAddAllQues(key);
    const lastElement = key[key.length - 1];

    const filteredObject = categoriesList?.filter(
      (_, index) => index === lastElement - 1
    )[0];


    // console.log(" addAllClicked && categoryName",addAllClicked , categoryName);

    // console.log(" newCatName",categoriesList[Number(addAllPanelKey?.[0])-1]?.category_name);
   if(updateAllDropdowns){
    let promises = key.map((index,i) =>
      getCategoryQuestions(
        categoriesList[index-1]?.category_name,
        index-1,
        scroll
      )
    );
    
    Promise.all(promises)
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
   }
    else if (filteredObject) {
      getCategoryQuestions(
        filteredObject?.category_name,
        lastElement,
        scroll
      ).finally(() => setLoading(false));
      setCategoryName(filteredObject.category_name);
      categoryNameRef.current = filteredObject.category_name;
      // commenting extra api call
      // getCategoryQuestions("Pinned");
    }
    // else if(addAllClicked && !loadingDisplayCategoryQuesData && categoryName){
    else if(addAllClicked && addAllPanelKey && categoriesList[Number(addAllPanelKey[0])-1]?.category_name){

      getCategoryQuestions(
        categoriesList[Number(addAllPanelKey[0])-1]?.category_name,
        lastElement,
        scroll
      ).finally(() => setLoading(false));
      // setCategoryName(filteredObject.category_name);
    }
    else{
      setLoading(false);
    }
  };

  //to get all the response Categories
 
  // Use refs to store counter elements and item data
  const counterRefs = useRef({});
  const itemDataRefs = useRef({});

  const getCategoryStatus = (categoryName, totalQuestions) => {
    
    if (!categoryStatusRef || !categoryStatusRef.current) return 'grey';
    
    // Find the category data from categoryStatusRef
    const categoryData = categoryStatusRef.current[categoryName];
   
    
    if (!categoryData) return 'grey';
    
    // If no questions array exists, use the original category_indicator
    if (!categoryData.questions || !Array.isArray(categoryData.questions)) {
        return categoryData.category_indicator;
    }
    
    // Count how many category questions are in the report
    const questionsInReport = categoryData.questions.filter(questionId => 
        quesInReport.includes(questionId)
    );
    
    
    const questionsInReportCount = questionsInReport.length;
    // putting question.length as question is updating for pinned but count is not changing
    const totalCategoryQuestions = categoryName=="Pinned"?categoryData?.questions?.length || categoryData.total_questions:categoryData.total_questions;

    // for normal categories
    // const totalCategoryQuestions = categoryData.total_questions;
   
    // Determine status based on count
    if (questionsInReportCount === 0) {
        // console.log("catcheck grey");
        return 'grey'; // No questions in report
    } else if (questionsInReportCount === totalCategoryQuestions) {
        // console.log("catcheck green");
        return 'green'; // All questions are in report
    } else {
        // console.log("catcheck yellow");
        return 'yellow'; // Some questions are in report
    }
};


function transformCategoryData(apiData, preserveExistingQuestions = false) {
    const result = {};
    
    apiData.forEach(category => {
        const { category_name, category_description, ...categoryData } = category;
        
        if (preserveExistingQuestions && categoryStatusRef.current[category_name]?.questions) {
            // Preserve existing question IDs if they exist
            result[category_name] = {
                ...categoryData,
                questions: categoryStatusRef.current[category_name].questions
            };
        } else {
            // Use new data without preserving questions
            result[category_name] = categoryData;
        }
    });
    
    return result;
}

// Keep your original getCategoriesForResponses function
const getCategoriesForResponses = async (updateUI=true) => {
    if(updateUI)
      setLoading(true);

    const payload = {
      user_id: userId,
      screen_name: screenName,
      search_string: searchString || "",
      analysis_id: localStorage.getItem("analysisId") || "",
      analysis_refresh_date: analysisData?.last_updated || "",
      ques_max_updated_ts: analysisData?.quesMaxUpdatedTs || "",
    };


    let response = await getResponsesCategory(payload);

    dispatch(setFilterData(response?.result?.comparator_data));
    setcategoriesAPIData(response?.result.categories_data);
    const categoriesData = response?.result.categories_data;
    // setting the ref
    categoryStatusRef.current =  transformCategoryData(response?.result.categories_data,!updateUI);
    setCategoryStatus(categoryStatusRef.current);
    if(!updateUI){
      // this will prevent dropdown from losign and opening
      // as we r not updating ui by re-rendering
      // we r updating ui through ref above
      return;
    }

    const catList = [];
    let useCaseObjList = [];

    categoriesData.forEach((item, index) => {
  
  
  // Store item data for later use in counter logic
  itemDataRefs.current[index] = item;
  
  const obj = {
    key: index + 1,
    category_name: item.category_name,
    label: (
      <div style={{ display: "flex" }}>
        <span className="catName">
          {item.category_name} ({item.total_questions})
        </span>
        <div className="catDesc">{item.category_description}</div>
        <div style={{
          paddingLeft: '250px',
          cursor: 'pointer',
          marginTop: 'auto',
          marginBottom: 'auto'
        }}>
          <Tooltip
            title={
              (!analysisData?.quesMaxUpdatedTs) ?
                <div>
                  Create a New Export or open existing Export
                  <br />
                  to enable export cards option
                </div>
                :
                <div>
                  Add All Questions <br />
                  to Export
                </div>
            }
          >
              <button
                disabled={(addAllClicked || !analysisData?.quesMaxUpdatedTs
                  || addMultipleCardsApiRunning || item.total_questions == 0) || !disableData}
                onClick={(e) => handleSubmitCheckbox(e, item, index)}
                style={{
                  border: 'none',
                  cursor: (addAllClicked || !analysisData?.quesMaxUpdatedTs
                    || addMultipleCardsApiRunning || item.total_questions == 0 || !disableData) ? 'not-allowed' : 'pointer',
                  paddingRight: '20px',
                  paddingLeft: '20px',
                  background: "transparent",
                  marginTop:'6px'
                }}
              >
                <img
                  style={{
                    width: '30px',
                    height: '25px'
                  }}
                  src={(addAllClicked || !analysisData?.quesMaxUpdatedTs
                    || addMultipleCardsApiRunningRef.current || item.total_questions == 0 || !disableData) ? AddAllCardsRightArrowDisabled : AddAllToReportArrowIcon}
                  alt="Add All To Export"
                />
              </button>
              {/* Use ref to update counter directly */}
             
           
          </Tooltip>
        </div>
         <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '20px',
            minHeight: '20px',
            // marginLeft: '10px', // Add some space from the button
            margin:'auto',
            flexShrink: 0 // Prevent shrinking
          }}
          ref={el => counterRefs.current[index] = el}>
          </div>
      </div>
    ),
    children: "",
  };
  catList.push(obj);
  
  const useCaseIdObj = {
    key: index + 1,
    category_name: item?.category_name,
    use_case_id: item?.use_case_id || null
  }
  useCaseObjList.push(useCaseIdObj);
    });
    
    setCategoriesList(catList);    
    dispatch(setUseCaseId(useCaseObjList));
    setLoading(false);
  };
  useEffect(() => {
  
  const updateStatusDots = () => {
    Object.keys(counterRefs.current).forEach(index => {
      const counterEl = counterRefs.current[index];
      const itemData = itemDataRefs.current[index];
      
      if (counterEl && itemData && IsReportOpen) {
        // Use the most current refs data
        const status = getCategoryStatus(itemData.category_name, itemData.total_questions);
                
        // Clear existing classes
        counterEl.classList.remove('status-indicator', 'status-green', 'status-yellow', 'status-grey');
        
        // Add base class
        counterEl.classList.add('status-indicator');
        
        // Set status-specific class and content
        if (status === 'green') {
          counterEl.classList.add('status-green');
          counterEl.innerHTML = '';
          counterEl.title = "Present in Export";
        } else if (status === 'yellow') {
          counterEl.classList.add('status-yellow');
          counterEl.innerHTML = '';
          counterEl.title = "Partially Present in Export";
        } else {
          counterEl.classList.add('status-grey');
          counterEl.innerHTML = '';
          counterEl.title = "Not Present in Export";
        }
      }
    });
  };
  
  // Multiple attempts to catch the state when it's ready
  setTimeout(updateStatusDots, catStatusTime);
  // setTimeout(updateStatusDots, catStatusTime + 2000);

  
}, [
  quesInReport,
  pinUnpinIsClicked, 
  updateTrigger.current,
  categoryStatus,
  categoryStatusRef
]);

  
function addPinnedCategory(refObj, apiResponse,categoryName) {
  
    // Extract question IDs where pinned_flag is true
    let allQuestionsId = [];
    if(categoryName==="Open Text Response Questions"){
      allQuestionsId = apiResponse
        ?.filter(question=>question)
        ?.map(question => question.ques_id);
    }
    else{
        allQuestionsId = apiResponse
        ?.filter(question => question.pinned_flag === true)
        ?.map(question => question.ques_id);
    }
  
    
    // Check if Pinned category already exists
    const pinnedCategoryIndex = refObj.findIndex(category => category.category === "Pinned");    
    const openCategoryIndex = refObj.findIndex(category => category.category === "Open Text Response Questions");

    if(openCategoryIndex!==-1){
       refObj[openCategoryIndex].questionIds = allQuestionsId;
      //  categoryStatusRef.current[categoryName].questions = allQuestionsId;
    }
    if (pinnedCategoryIndex !== -1) {
        // If Pinned category exists, update it
        // categoryStatusRef.current[categoryName].questions = allQuestionsId;
        refObj[pinnedCategoryIndex].questionIds = allQuestionsId;
    } else {
        // If Pinned category doesn't exist, add it
        refObj.push({
            category: categoryName,
            questionIds: allQuestionsId
        });
    }
  
    categoryStatusRef.current[categoryName].questions = allQuestionsId;
  
    
    // setCatQuesMapState(refObj);

    return refObj;
}



function addQuestionsToCategory(categoryName, questionsData) {
  let transformedData = { ...categoryStatusRef.current };
  
  // Extract question IDs from the questions data
  const questionIds = questionsData.map(question => question.ques_id);
  
  // Special handling for "Pinned" and "Open Text Response" categories
  if (categoryName === "Pinned" || categoryName === "Open Text Response Questions") {
    // Add questions to the specified category
    if (transformedData[categoryName]) {
      transformedData[categoryName].questions = questionIds;
    }
    
    // Also add questions to their original categories
    questionsData.forEach(question => {
      const originalCategory = question.ques_category_name;
      if (transformedData[originalCategory]) {
        // Initialize questions array if it doesn't exist
        if (!transformedData[originalCategory].questions) {
          transformedData[originalCategory].questions = [];
        }
        // Add question ID if it's not already present
        if (!transformedData[originalCategory].questions.includes(question.ques_id)) {
          transformedData[originalCategory].questions.push(question.ques_id);
        }
      }
    });
  } else {
    // Normal case: add questions to the category they belong to
    questionsData.forEach(question => {
      // const categoryKey = question.ques_category_name;
      // changed from above to below for usecase
      const categoryKey = categoryName;
      if (transformedData[categoryKey]) {
        // Initialize questions array if it doesn't exist
        if (!transformedData[categoryKey].questions) {
          transformedData[categoryKey].questions = [];
        }
        // Add question ID if it's not already present
        if (!transformedData[categoryKey].questions.includes(question.ques_id)) {
          transformedData[categoryKey].questions.push(question.ques_id);
        }
      }
    });
  }
  
  // Update the ref and state
  categoryStatusRef.current = transformedData;
  setCategoryStatus(transformedData);
  
  return transformedData;
}

function getUseCaseIdByCategoryName(array, categoryName) {
    const item = array.find(obj => obj.category_name === categoryName);
    return item ? item.use_case_id : null; // Returns use_case_id or null if not found
}
  //to get all the questions for the category
  const getCategoryQuestions = async (categoryName, panelKey, scroll) => {
    // console.log(" getCategoryQuestions");
    
    const useCaseId = getUseCaseIdByCategoryName(useCaseData, categoryName);
   
    let skipApiCall = false;

    // to skip extra api call on pin in usecase screen
    if(useCaseId==null && categoryName!="Pinned" && screenName=="View Use Case"){
      skipApiCall = true;
    }
    // console.log("filterData",filterData);
    
    const payload = {
      user_id: userId,
      screen_name: "response_details",
      use_case_id:useCaseId,
      search_string: searchString || "",
      category_name: categoryName,
      analysis_id: localStorage.getItem("analysisId") || "",
      analysis_refresh_date: analysisData?.last_updated || "",
      ques_max_updated_ts: analysisData?.quesMaxUpdatedTs || "",
      allowed_geographies: userInfo?.allowed_geographies || [],
      allowed_indications:userInfo?.allowed_indications || [],
      comparator_data:
        filterData.length > 0
          ? filterData
          : [
              {
                age: null,
                race: null,
                gender: null,
                ethnicity: null,
                geography: null,
                indication: null,
                comparator_nm: "",
                origin_country: null,
                sub_indication: null,
                therapeutic_area: null,
              },
            ],
    };
    let response = {};
    if(!skipApiCall){
      response = await getQuestionsByCategory(payload);
      if(categoryName=="Pinned"){
        // catQuesMap.current
        addPinnedCategory(catQuesMap.current, response?.result,categoryName);
      }
      // add id and length if category is pinned. into ref
      if(response?.result?.length > 0){        
        setIsApiResponseReceived(true);  
        addQuestionsToCategory(categoryName,response?.result);
      }
     
    }
    // console.log("iron category",categoryName);
    // setCatQuesMapState(catQuesMap.current);
    // console.log("iron resp",response);
    

    if (response?.result?.length > 0) {
      buildOutput(response.result, categoryName, panelKey, scroll);
    }
    setNewCardsAddedLength(response?.total_supp_cards);
    // console.log("response.result",response.result);
    // console.log("addAllApiData addAllquestionsClicked",addAllquestionsClicked);

    // if(addAllquestionsClicked){
      // console.log("addAllApiData addAllquestionsClicked",addAllquestionsClicked);
     
      let temp = await processQuestionData(response?.result,categoryName);
      addAllApiDataRef.current=temp;
      setAddAllApiData(temp);
      setApiCounter((prev)=>prev+1)
      
      setAddAllQues(response?.result?.[0]?.ques_id);
    // }
    // setQuestionsToCategory(categoryName);
    return response;
  };

  // to pin/unpin the questions
  
  const pinUnpinQuestionClicked = async (record, actionValue,category) => {
  setLoading(true);
  setPinUnpinIsClicked((prev) => prev + 1);


  const payload = {
    user_id: userId,
    ques_id: record.id,
    screen_name: "explore_responses",
    action: actionValue,
    analysis_id: localStorage.getItem("analysisId") || "",
    analysis_refresh_date: analysisData?.last_updated || "",
    ques_max_updated_ts: analysisData?.quesMaxUpdatedTs || "",
  };

  await setPinUnpinQuestions(payload);
  setPinUnpinIsClicked((prev) => prev + 1);

  categoriesAPIData[0].total_questions =
    actionValue === "pin"
      ? categoriesAPIData[0].total_questions + 1
      : categoriesAPIData[0].total_questions - 1;

  // IMPORTANT: Update itemDataRefs to keep it in sync
  // itemDataRefs.current[0] = categoriesAPIData[0];

  // console.log("itemDataRefs catAPIData",categoriesAPIData);
  
  // console.log("itemDataRefs.current",itemDataRefs.current);
  

  const obj = {
    key: 1,
    category_name: categoriesAPIData[0].category_name,
    label: (
      <div style={{ display: "flex" }}>
        <span className="catName">
          {categoriesAPIData[0].category_name} (
          {categoriesAPIData[0].total_questions})
        </span>
        <div className="catDesc">
          {categoriesAPIData[0].category_description}
        </div>
        <div style={{
            paddingLeft:'250px',
            cursor:'pointer', 
            marginTop:'auto',
            marginBottom:'auto'}}>
          <Tooltip
             title={
              ( !analysisData?.quesMaxUpdatedTs 
              )?
              <div>
                Create a New Export or open existing Export
                <br />
                to enable export cards option
              </div>
              :
              (
              <div>
                Add All Questions <br />
                to Export
              </div>
              )
            }
            
            
            >
            <button
             disabled={addAllClicked || !analysisData?.quesMaxUpdatedTs 
              || addMultipleCardsApiRunning || categoriesAPIData[0].total_questions==0 || !disableData}
             onClick={(e)=>handleSubmitCheckbox(e,categoriesAPIData[0],0)} 
            style={{border:'none' , cursor:(addAllClicked || !analysisData?.quesMaxUpdatedTs 
              || addMultipleCardsApiRunning || categoriesAPIData[0].total_questions==0 || !disableData)?'not-allowed':'pointer', paddingRight:'20px' , paddingLeft:'20px',
            background:'transparent'
            }}
            >
              <img
              style={{
                width:'30px',
                height:'25px'
              }}
              src={(addAllClicked || !analysisData?.quesMaxUpdatedTs 
                || addMultipleCardsApiRunningRef.current || categoriesAPIData[0].total_questions==0 || !disableData)?AddAllCardsRightArrowDisabled:AddAllToReportArrowIcon}
              alt="Add All To Export"
              />
            </button>
            
            {/* Add the ref div here to match the structure from getCategoriesForResponses */}
          
            
          </Tooltip>
          
        </div>
          <div 
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '20px',
                minHeight: '20px',
                // marginLeft: '10px', // Add some space from the button
                margin:'auto',
                flexShrink: 0 // Prevent shrinking
              }}
            ref={el => {
              // console.log(`Setting ref for Pinned category (index 0):`, el);
              counterRefs.current[0] = el;
            }}
            >
              {/* This will be updated by useEffect with the status dot */}
            </div>
      </div>
    ),
    children: "",
  };

  categoriesList[0] = obj;
  
  // Force update of the categoriesList state to trigger re-render
  setCategoriesList([...categoriesList]);
  
  getCategoryQuestions(record.categoryName);
  // for making pin/unpin working for open-text
  if(category==="Open Text Response Questions")
    getCategoryQuestions("Open Text Response Questions");
  getCategoryQuestions("Pinned");
  setLoading(false);
  setUseCaseKey(record?.panelKey ? record?.panelKey: '1');
  updateTrigger.current += 1;
};

  const highlightRowFun = () => {
    // setRowToHighLight(highlightRow);
    highlightRowHandler(highlightRow.panel_key);
  };

  useEffect(() => {
    onChange([]);
    getCategoriesForResponses();
  }, [filterAppliedData, searchString, edit_access_flag]);

  
  useEffect(() => {
    // this is called when card is deleted .
    // and don't call if delete is not performed
    if(counter==0){
      return;
    }
    setTimeout(() => {
        getCategoriesForResponses(false);
    }, 1000);
  }, [counter]);


  useEffect(() => {
    if(screenName=="View Use Case"){      
      onChange([useCaseKey],true);
    }
  }, [useCaseKey,updateTrigger.current]);

  useEffect(() => {
    highlightRowFun();
  }, [highlightRow]);

  useEffect(() => {
    // setLoading(true);
    onChange([...activeKeys]);
  }, [deleteCardRefresh]);

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 30,
      }}
      spin
    />
  );

  const highlightRowHandler = (panelKey) => {
    // {
    //   categoryName: "",
    //   panelKey: 5,
    //   questionId: 5,
    // }
    // rowToHighLight
    // activeKeys
    if (panelKey) {
      onChange([...activeKeys, panelKey], true);
    }

    // setActiveKeys([rowToHighLight.panelKey]);
  };

  return (
    <>
    {/* analysisData?.totalCards + newCardsAddedLength)-MAX_ALLOWED_CARDS */}
  
      <Spin 
      // tip={loadingTip} 
      tip={<div >{loadingTip}</div>} 

      indicator={antIcon} spinning={(loading || addAllToReportloading) && !loadingDisplayCategoryQuesData}
      style={{
        position: 'fixed',   // Keeps it fixed on the screen even when scrolling
        top: '50%',          // Vertically center it
        left: '50%',
        right:'50%',
        transform: 'translate(-50%, -50%)', // Perfect centering
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // zIndex: 9,                    // Ensure it appears above other content
        pointerEvents: 'none',
        // background: 'transparent',     // Ensure no background color is added to the spinner

    }}
      >
      {/* { exceedCards>0 && isModalOpen && (<Modal
        closable={false}
        maskClosable={false}
        open={isModalOpen}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setExceedCards(0);
              setIsModalOpen(false); // Close modal when the button is clicked
            }}
            style={{ backgroundColor: "#27A6A4" }}>
            OK
          </Button>
        ]}>
        <p><strong>{`Currently $ ${totalNumberOfCardsRef.current}/${MAX_ALLOWED_CARDS} cards have been added to export. Current Selection of category exceeds the threshold by ${exceedCards} ${exceedCards==1?'card':'cards'}.`}
        </strong></p>
        <p><strong>{`Please delete/unselect ${exceedCards} cards to proceed to be added to export Section.`}</strong></p>

      </Modal>)} */}
  <Modal
        title={
          <div className="flex items-center gap-2">
            <span>Download Unavailable</span>
          </div>
        }
        open={isEmptyExportUrl}
        onOk={()=>setIsEmptyExportUrl(false)}
        onCancel={()=>setIsEmptyExportUrl(false)}
        footer={[
          <Button key="ok" type="primary" 
          onClick={()=>setIsEmptyExportUrl(false)}
          >
            OK
          </Button>
        ]}
        centered
        width={400}
      >
        <div className="text-center py-4">
         <div>No Open Text Responses available for selected filters</div>
        </div>
      </Modal>
       

      {/* {  (doubleClickCheck && 
      // isApiResponseReceived 
      addMultipleApiRunning.current )&& (<Modal
        closable={false}
        maskClosable={false}
        open={true}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setDoubleClickCheck(false)// Close modal when the button is clicked
            }}
            style={{ backgroundColor: "#27A6A4" }}>
            OK
          </Button>
        ]}>
        <p><strong>{`Currently ${analysisData?.totalCards}/${MAX_ALLOWED_CARDS} cards have been added to report. Current Selection of category exceeds the threshold by ${exceedCards} ${exceedCards==1?'card':'cards'}.`}
        </strong></p>
        <p><strong>{`Please delete/unselect ${exceedCards} cards to proceed to be added to report Section.`}</strong></p>

      </Modal>)} */}

        <div>
          {/* {isOpen && (
            <FindingReportSettingsModal
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              supporting_data={supportingData}
              filterData={filterData}
              recordData={recordData}
              type={"category_responses"}
            />
          )} */}
          <Collapse
            items={categoriesList}
            activeKey={activeKeys}
            collapsible="header"
            onChange={onChange}
          />
        </div>

        {respondentFilterFlag ? (
          <div>
            <ResponseDetails
              visible={true}
              responseRowRecord={responseRowRecord}
              categoryName={categoryName}
              comparatorData={filterData}
              onClose={() => responseDetailDrawer(false)}
              addAllCards={false}
              headerCategoryName={categoriesList[currentPanelKey-1]?.category_name}
            />
          </div>
        ) : (
          ""
        )}
         {callResponseDetails ? (
          <div>
            <ResponseDetails
              visible={false}
              responseRowRecord={responseRowRecord}
              categoryName={categoryName}
              comparatorData={filterData}
              onClose={() => responseDetailDrawer(false)}
              addAllCards={callResponseDetails}
              setCallResponseDetails={setCallResponseDetails}
              setAddAllToReportLoading={setAddAllToReportLoading}
              headerCategoryName={categoriesList[currentPanelKey-1]?.category_name}
              
            />
          </div>
        ) : (
          ""
        )}
      </Spin>
    </>
  );
};

export default ExploreResponseDetails;
